import React from "react"
import { Link } from "react-router-dom"

import PageBanner from "../../layouts/PageBanner"

//images
import bg from "../../assets/images/banner/bnr4.jpg"
import shape2 from "../../assets/images/pattern/shape2.png"
import shape3 from "../../assets/images/pattern/shape3.png"
import shape5 from "../../assets/images/pattern/shape5.png"
import shape1 from "../../assets/images/pattern/shape1.png"
import shape6 from "../../assets/images/pattern/shape6.png"
import { Table } from "reactstrap"
import YouthWingBlock from "../../components/YouthWingBlock"
import YouthClubBlock from "../../components/YouthClubBlock"
import YouthClubBook from "../../components/YouthClubBook"

// Members
import Avatar from "../../assets/images/SATS club/youth/Members/avatar.jpg"
import Amiitesh from "../../assets/images/SATS club/youth/Members/amiithesh_danushkodi.png"
import Saadhana from "../../assets/images/SATS club/youth/Members/saadhana_vijay.png"
import Sneha from "../../assets/images/SATS club/youth/Members/sneha_gupta.png"
import Joshitha from "../../assets/images/SATS club/youth/Members/joshitha_jasper_premkumar.png"
import nishitha from "../../assets/images/SATS club/youth/Members/Nishitha_Shri_Sasi_Kumar.jpg"
import sanjay from "../../assets/images/SATS club/youth/Members/Sanjay_Rajaguru.png"
import sachin from "../../assets/images/SATS club/youth/Members/Sachin_Kumar.png"
import nanthana from "../../assets/images/SATS club/youth/Members/Nanthana_Bhavani_Satish_Kumar.png"
import taarika from "../../assets/images/SATS club/youth/Members/Taarika_Udayakumaran.png"
import steffi from "../../assets/images/SATS club/youth/Members/Steffi_Maria_Oviya_Prem.png"
import dhiyarsi from "../../assets/images/SATS club/youth/Members/Dhiyarsi_Thirumurugan.png"
import mihira from "../../assets/images/SATS club/youth/Members/Mihira_Premanand.png"
 import sivakami from "../../assets/images/SATS club/youth/Members/Sivakami_Subramanian.png"
import Sarayu from "../../assets/images/SATS club/youth/Members/sarayu_lokeshkumar.png"
import Achuthakrish from "../../assets/images/SATS club/youth/Members/achuthakrish_thumatichandrasekaran.png"
import Jonathan from "../../assets/images/SATS club/youth/Members/jonathan_gladwin_prabakar.png"
import Aventhi from "../../assets/images/SATS club/youth/Members/aventhi_dharani.png"

import YouthWingDiscussion from "../../components/YouthWingDiscussion"
const YouthWing = () => {
  const YouthWingMembers = [
    {
      name: "Joshitha Jasper Premkumar",
      image: Joshitha,
      Role: "President",
    },
    {
      name: "Sneha Gupta",
      image: Sneha,
      Role: "Vice President",
    },
    {
      name: "Taarika Udayakumaran",
      image: taarika,
      Role: "Secretary",
    },
    {
      name: "Sanjay Rajaguru",
      image: sanjay,
      Role: "Joint Secretary",
    },
    {
      name: "Nanthana Bhavani Satish Kumar",
      image: nanthana,
      Role: "Treasurer",
    },
    {
      name: "Steffi Maria Oviya Prem",
      image: steffi,
      Role: "Executive Committee Member",
    },
    {
      name: "Dhiyarsi Thirumurugan",
      image: dhiyarsi,
      Role: "Executive Committee Member",
    },
    {
      name: "Mihira Premanand",
      image: mihira,
      Role: "Executive Committee Member",
    },
    {
      name: "Nishitha Shri Sasi Kumar",
      image: nishitha,
      Role: "Executive Committee Member",
    },
    {
      name: "Sachin Kumar",
      image: sachin,
      Role: "Executive Committee Member",
    },
    {
      name: "Sivakami Subramanian",
      image: sivakami,
      Role: "Executive Committee Member",
    },


    // {
    //   name: "Saadhana Vijay",
    //   image: Saadhana,
    //   Role: "President",
    // },
    // {
    //   name: "Amiithesh Danushkodi",
    //   image: Amiitesh,
    //   Role: "Secretary",
    // },
    // {
    //   name: "Sneha Gupta",
    //   image: Sneha,
    //   Role: "Executive Committee Member",
    // },
    // {
    //   name: "Joshitha Jasper Premkumar",
    //   image: Joshitha,
    //   Role: "Executive Committee Member",
    // },
    // {
    //   name: "Sarayu Lokeshkumar",
    //   image: Sarayu,
    //   Role: "Executive Committee Member",
    // },
    // {
    //   name: "Achuthakrish Thumatichandrasekaran",
    //   image: Achuthakrish,
    //   Role: "Executive Committee Member",
    // },
    // {
    //   name: "Jonathan Gladwin Prabakar",
    //   image: Jonathan,
    //   Role: "Executive Committee Member",
    // },
    // {
    //   name: "Aventhi Dharani",
    //   image: Aventhi,
    //   Role: "Executive Committee Member",
    // },
  ]
  return (
    <>
      <div className="page-content bg-white text-dark">
        <PageBanner maintitle="Home" pagetitle="Youth Wing" />
          <section
          className="content-inner-2 bg-light section-pattren1"
          style={{ paddingTop: 30 }}>
          <YouthWingDiscussion/>
          </section>


        <section
          className="content-inner-2 bg-light section-pattren1"
          style={{ paddingTop: 30 }}
        >
          <div className="container">
            <div className="row about-bx3 align-items-center">
              <YouthWingBlock />
            </div>
          </div>

          <img src={shape2} className="shape-6 move-2" alt="shape" />
          <img src={shape3} className="shape-5 move-1" alt="shape" />
          <img src={shape5} className="shape-1 rotating" alt="shape" />
          <img src={shape1} className="shape-3 move-1" alt="shape" />
          <img src={shape6} className="shape-4 rotating" alt="shape" />
          <img src={shape6} className="shape-2 rotating" alt="shape" />
        </section>
        <section
          className="content-inner-2 section-pattren1"
          style={{ paddingTop: 50 }}
        >
          <div className="container">
            <div className="row about-bx3 align-items-center">
              <YouthClubBlock />
            </div>
          </div>
          {/* <div className="container">
            <div className="row about-bx3 align-items-center">
              <YouthClubBook />
            </div>
          </div> */}

          <img src={shape2} className="shape-6 move-2" alt="shape" />
          <img src={shape3} className="shape-5 move-1" alt="shape" />
          <img src={shape5} className="shape-1 rotating" alt="shape" />
          <img src={shape1} className="shape-3 move-1" alt="shape" />
          <img src={shape6} className="shape-4 rotating" alt="shape" />
          <img src={shape6} className="shape-2 rotating" alt="shape" />
        </section>
        <section
          className="content-inner-2 section-pattren1"
          style={{ paddingTop: 50 }}
        >
          <div className="container">
            <div className="row">
              <h2 className="text-primary text-center border-bottom pb-2">
                Youth Wing Team
              </h2>
              <Table hover>
                <thead>
                  <tr>
                    <th>Profile</th>
                    <th>Name</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {YouthWingMembers.map((item, ind) => (
                    <tr>
                      <td>
                        <div style={{ height: "100px", width: "100px" }}>
                          <img src={item.image} style={{ width: "100%" ,height: "100%", objectFit: "contain"}}></img>
                        </div>
                      </td>
                      <td className="align-self-center">{item.name}</td>
                      <td>{item.Role}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>

          <img src={shape2} className="shape-6 move-2" alt="shape" />
          <img src={shape3} className="shape-5 move-1" alt="shape" />
          <img src={shape5} className="shape-1 rotating" alt="shape" />
          <img src={shape1} className="shape-3 move-1" alt="shape" />
          <img src={shape6} className="shape-4 rotating" alt="shape" />
          <img src={shape6} className="shape-2 rotating" alt="shape" />
        </section>
      </div>
    </>
  )
}

export default YouthWing
